<template>
	<div class="company-shipping-card">
		<div class="company-shipping-card__item">
			<span class="company-shipping-card__item-label">Code:</span>
			{{ item.code }}
		</div>

		<div class="company-shipping-card__item">
			<span class="company-shipping-card__item-label">URL:</span>
			{{ item.url }}
		</div>

		<div class="company-shipping-card__item">
			<span class="company-shipping-card__item-label">Description:</span>
			{{ item.description }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'CompanyShippingCard',
	components: {},
	props: {
		item: {
			type: Object,
			default: () => {}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/scss/5-objects/_cards.scss';

.company-shipping-card {
	@include card;
	width: 319px;

	&__item {
		@include body-text('regular');

		&:not(:last-child) {
			margin-bottom: $gutter-sm;
		}

		&-label {
			color: $neutral-2;
		}

		&-label {
			color: $neutral-2;
		}
	}
}
</style>
